import { render, staticRenderFns } from "./RiskLogOptions.vue?vue&type=template&id=187c79ae&scoped=true"
import script from "./RiskLogOptions.vue?vue&type=script&lang=ts"
export * from "./RiskLogOptions.vue?vue&type=script&lang=ts"
import style0 from "./RiskLogOptions.vue?vue&type=style&index=0&id=187c79ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c79ae",
  null
  
)

export default component.exports